import React from "react";
import { Box, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

export default function MainPoolDetails({ totalAmount, withDistributors, withUsers, remainingAmount, onDistributeClick }) {
  const classes = useStyles();
  
  return (
    <Box className={classes.statsContainer}>
      <Box className={classes.statRow}>
        <Box className={classes.statItem}>
          <Typography variant="body2" className={classes.statLabel}>
            Total Amount
          </Typography>
          <Typography variant="h5" className={classes.statValue}>
            {totalAmount}
          </Typography>
        </Box>
        <Box className={classes.statItem}>
          <Typography variant="body2" className={classes.statLabel}>
            With Distributors
          </Typography>
          <Typography variant="h5" className={classes.statValue}>
            {withDistributors}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.statRow}>
        <Box className={classes.statItem}>
          <Typography variant="body2" className={classes.statLabel}>
            With Users
          </Typography>
          <Typography variant="h5" className={classes.statValue}>
            {withUsers}
          </Typography>
        </Box>
        <Box className={classes.statItem}>
          <Typography variant="body2" className={classes.statLabel}>
            Remaining
          </Typography>
          <Typography variant="h5" className={classes.statValue}>
            {remainingAmount}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.buttonContainer}>
        <Button
          variant="contained"
          color="primary"
          onClick={onDistributeClick}
          className={classes.distributeButton}
        >
          <Typography className={classes.buttonLabel}>Distribute</Typography>
        </Button>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  statsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    width: "100%",
  },
  statRow: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2),
    width: "100%",
  },
  statItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(1.5),
    backgroundColor: "#f5f5f5",
    borderRadius: theme.shape.borderRadius,
    flex: 1,
  },
  statLabel: {
    color: "rgb(135, 131, 131)",
    marginBottom: theme.spacing(0.5),
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  statValue: {
    color: "rgb(100, 100, 100)",
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
    width: "100%",
  },
  distributeButton: {
    minWidth: 150,
  },
  buttonLabel: {
    fontWeight: "bold",
  },
}));
